<template>
          <div class="quotes">
              <div ref="quotesFilters"
                   class="search-bar">
                  <quotes-auto-complet :placeholder="localizeList.departTo"
                                       :items2="allCountryTo"
                                       :second-items="allCitiesTo"
                                       @focus="focusFilter('cityTo')"
                                       @valid="tourToIsValid = $event"
                                       @get-cities="getCitiesToWithCash($event)"
                                       second
                                       multiply
                                       v-model="searchTour.to"
                                       class="search-bar-item"/>
                  <quotes-auto-complet-combo :placeholder="localizeList.hotelUpper"
                                             :items="comboItems"
                                             :all-items="comboAllItems"
                                             :disabled="searchTour.to.length < 2"
                                             :focus-from-parent="focusFilterTo"
                                             :loading="comboItemsLoading"
                                             :selected-items-on-reboot="selectedItemsOnReboot"
                                             @inputValue="inputValueComboFilter = $event"
                                             @focus="scrollToFilter"
                                             @search="searchCombo"
                                             @changeHotelsKeys="hotelsKeys = $event"
                                             @setComboItem="searchTour.combo = $event"
                                             v-model="searchTour.combo"
                                             class="search-bar-item"/>
                  <quotes-calendar :placeholder="localizeList.whenUpper"
                                   v-model="date"
                                   @reload="reloadDate()"
                                   @focus="scrollToFilter()"
                                   @press-tab="focusPeopleCounter()"
                                   @change-days="changeDays($event)"
                                   @select-close="filterBlur($event)"
                                   :disabled="!inputValueComboFilter"
                                   :focus-from-parent="focusFilterDate"
                                   :days-count="daysCount"
                                   :active-dates="activeDates"
                                   class="search-bar-item"/>
                  <div class="search-bar-item days-count">
                    <label class="days-count-label">
                      <input v-model="quotesDaysCount"
                             @input="maskInputForNumber($event, 90)"
                             class="days-count-input">
                      <span  class="grey-text">{{localizeList.days}}</span>
                    </label>
                  </div>

                  <base-button @click="search()"
                               ref="searchButton"
                               :background="'var(--orange-color)'"
                               padding="4px 24px"
                               :searchLoaderStatus="searchLoaderStatus">
                      <svg v-if="!searchLoaderStatus" width="24px" height="24px" fill="var(--white-color)">
                          <use xlink:href="../../assets/images/sprite.svg#search"></use>
                      </svg>
                      <base-loader v-else size="22" weight="5"/>
                  </base-button>

                  <validation-popup :text="validationText" v-model="validationShow"/>
              </div>

              <div class="quotes-settings">
                <div class="setting-items">
                  <div class="setting-item">
                    <span class="seats">{{getQuotaDescription.seatsQuotaDescription}}</span>
                    <span>{{"– " + localizeList.available}}</span>
                  </div>
                  <div class="setting-item">
                    <span class="request-seats">{{getQuotaDescription.reqSeatsQuotaDescription}}</span>
                    <span>{{"– " + localizeList.onRequest}}</span>
                  </div>
                  <div class="setting-item">
                    <span class="no-seats">{{getQuotaDescription.noSeatsQuotaDescription}}</span>
                    <span>{{"– " + localizeList.quotaHasNoPlaces}}</span>
                  </div>
                  <div class="setting-item">
                    <span class="few-seats">{{getQuotaDescription.fewSeatsQuotaDescription}}</span>
                    <span>{{"– " + localizeList.fewPlaces}}</span>
                  </div>
                </div>
              </div>

              <quotes-datepicker v-show="getShowQuotes"
                                 :period="quotesDaysCountAfterSearch" 
                                 :start="date.dates"
                                 :getShowQuotes="getShowQuotes"
                                 @send-dates-iso="setDatesISO"
                                 :currentLocalize="currentLocalize"
                                 :fixedDatepicker="fixedDatepicker"/>
          </div>
</template>

<script>
    import * as methods from "@/plugins/methods.js"
    import moment from "moment"

    import {bus} from '../../main.js'

    import Vue from 'vue'

    import * as mTypesTour from "@/stores/modules/tour/mutation_types"
    import * as mTypesQuotes from "@/stores/modules/quotes/mutation_types"

    import quotesAutoComplet from "../quotes/quotesAutoComplet";
    import quotesAutoCompletCombo from "../quotes/quotesAutoCompletCombo";
    import quotesCalendar from "../quotes/quotesCalendar";
    import quotesDatepicker from "../quotes/quotesDatepicker";
    import validationPopup from "../baseComponents/validationPopup";
  
    export default {
        name: "quotes-search",
        components: {
            quotesAutoComplet,
            quotesAutoCompletCombo,
            quotesCalendar,
            validationPopup,
            quotesDatepicker
        },
        props: {
          currentLocalize: String
        },
        data() {
            return {
                API_URL: this.$store.getters['getApiUrl'],
                date: {},
                searchTour: {
                    from: "",
                    to: "",
                    combo: {},
                    tourType: [],
                },
                allCountryTo: {
                    title: "Все варианты",
                    items: []
                },
                comboAllItems: [],
                comboItems: [],
                allCitiesTo: [],
                daysCount: [],
                daysCountCash: [],
                activeDates: [],
                pagination: {
                    page: 1,
                    perPage: 20
                },
                cashComboSearchValue: "",
                validationShow: false,
                validationText: "",
                urlSearchStatus: true,
                focusFilterTo: false,
                focusFilterDate: false,
                countryOldApi: null,
                comboItemsLoading: false,
                quotesDaysCount: "30",
                quotesDaysCountAfterSearch: "0",
                hotelsKeys: [],
                datesISO: [],
                selectedItemsOnReboot: [],
                fixedDatepicker: false,
                lastScrollPosition: 0,
                inputValueComboFilter: ""
            }
        },
        created() {
            bus.$on("change-search-type", (type) => {
              if (type === "quotes") {
                this.getQuotaSettings()
                this.setFiltersOfUrl();
                this.getCountryTo();
              }
            });
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
            const path = this.$route.fullPath.includes("Individuals/Quotes");
            if (path) {
                this.getQuotaSettings()
                this.setFiltersOfUrl();
                this.getCountryTo();
              }

            },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        computed: {
            getFirstPageLoadFlag() {
                return this.$store.getters['quotes/getFirstPageLoadFlag']
            },
            getShowQuotes() {
                return this.$store.getters['quotes/getShowQuotes']
            },
            dayMode() {
                return this.getSettings.TourSearchMode
            },
            getWindowSettings() {
                return window.settings;
            },
            searchLoaderStatus() {
                return this.$store.getters['tour/getSearchLoaderStatus']
            },
            getSettings() {
                return this.$store.getters['getSettings']
            },
            hasBasket() {
                return this.$route.fullPath.includes("Basket") || false
            },
            getQuotaDescription() {
                return this.$store.getters['quotes/getQuotaDescription']
            },
        },
        methods: {
            setFiltersOfUrl() {
                let params = this.$route.fullPath.split("Individuals/Quotes/")[1];
                if (!params)
                    return;

                params = params.split("&");

                let countryKeys = [];
                let citiesKeys = [];
                let filterHotels = [];
                let date = {
                    dates: [],
                    daysCount: { from: "", to: "" }
                };

                params.forEach(x => {
                    if (x.includes("countryKey")) {
                        let item = +x.split("=")[1];
                        countryKeys.push(item);
                    }
                    if (x.includes("cityKey")) {
                        x.split("=")[1].split(",").forEach(x2 => {
                            citiesKeys.push(+x2);
                        })
                    }
                    if (x.includes("hotelsKey")) {
                        x.split("=")[1].split(",").forEach(x2 => {
                            filterHotels.push(+x2);
                            this.hotelsKeys.push(+x2);
                        })
                    }
                    if (x.includes("dateFirst")) {
                        let item = x.split("=")[1];
                        const itemDate = moment(item, 'DD.MM.YYYY');
                        const currentDate = moment();

                        if (itemDate.isSameOrAfter(currentDate, 'day')) {
                            date.dates.push(itemDate.format('DD.MM.YYYY'));
                        }
                    }
                    if (x.includes("period")) {
                        let item = x.split("=")[1];
                        this.maskInputForNumber(item, 90, true);
                    }
                });
                document.cookie = `quotesTo=${JSON.stringify([...countryKeys, ...citiesKeys])}; path=/`;
                document.cookie = `quotesHotels=${JSON.stringify(filterHotels)}; path=/`;
                document.cookie = `quotesDate=${JSON.stringify(date)}; path=/`;
            },
            setDatesISO(items) {
                this.$store.commit("quotes/" + mTypesQuotes.M_SET_DATES_ISO, items)
            },
            maskInputForNumber(event, range, notObject = false) {
                let value = notObject ? event : event.target.value;
                let numericValue = value.replace(/[^0-9]/g, "");
                numericValue = numericValue === '0' ? '1' : numericValue;
                numericValue = numericValue > range ? range.toString() : numericValue;

                if (!notObject) {
                  event.target.value = numericValue;
                }
                this.quotesDaysCount = numericValue;
            },
            replaceUrl() {
                let isBascket = this.$route.fullPath.includes("Basket");

                // Проверяем на карректность урла
                if (
                    !location.href.includes("#/?") &&
                    (location.href.includes("/?") || (location.href.includes("?") && !isBascket))
                ) {
                    location.href = location.href
                        .replace(/#\/.+|#\//, "")
                        .replace("/?", "#/")
                        .replace("?", "#/");
                    return;
                }

                if (!this.$route.fullPath.includes("?") || isBascket) return;

                const newUrl = this.$route.fullPath.replace("?", "");
                if (!this.$route.path.includes(newUrl)) {
                    this.$router.push(newUrl);
                }
            },
            translit(text) {
                if (!text) return "";
                return this.$store.getters['translit'](text, 5)
            },
            cashComboSearchFunc() {
                this.searchComboFunc = methods.cachingDecorator(this.searchComboFunc);
            },
            searchCombo(e) {
              //  if (!e) {
              //       this.comboItems = [];
              //       return;
              //  }

               this.comboItems = this.searchComboFunc(e);
            },
            searchComboFunc(e) {
                const res = [];
                const text = e.toLowerCase().trim();
                const textIsLat = text.match(/[A-Za-z]/);
                const textTranslit = this.translit(text);
                let items = this.comboAllItems;
                if (this.cashComboSearchValue && e.slice(0, -1) === this.cashComboSearchValue && this.comboItems.length) {
                    items = this.comboItems
                }
                this.cashComboSearchValue = e;
                items.forEach(x => {
                    const item = {...x};

                    const mapResByText = res.map(x3 => x3.text);
                    const hotelText = item.categoryName ? `${item.hotelName} (${item.categoryName})` : item.hotelName;

                    const includeHotel =
                        (item.hotelName?.toLowerCase()?.includes(text) ||
                        (item.hotelName?.match(/[A-Za-z]/) || textIsLat) &&
                        this.translit(item.hotelName).toLowerCase().includes(textTranslit)) && !mapResByText.includes(hotelText);

                    const includeCategory =
                        (item.categoryName?.toLowerCase()?.includes(text) ||
                        (item.categoryName?.match(/[A-Za-z]/) || textIsLat) &&
                        this.translit(item.categoryName).toLowerCase().includes(textTranslit)) && !mapResByText.includes(hotelText);

                    if (includeHotel) {
                        item.isHotel = true;
                        item.isCategory = false;
                        item.text = hotelText;

                        const includeItem = mapResByText.includes(item.text);
                        if (!includeItem) {
                            res.push({...item});
                        }
                    } else if (includeCategory) {
                        item.isHotel = false;
                        item.isCategory = true;
                        item.text = hotelText;

                        const includeItem = mapResByText.includes(item.text);
                        if (!includeItem) {
                            res.push({...item});
                        }
                    }
                });

                // Проверяем есть ли объект с id -1 и если нет, то добавляем его в начало массива
                const checkIdForMinusOne = res.find(x => x.id == -1);
                if (!checkIdForMinusOne && res.length) {
                    const idMinusOneItem = {
                        hotelName: this.localizeList.all,
                        hotelKey: -1,
                        categoryName: "",
                        categoryKey: "",
                        isHotel: true,
                        isCategory: false,
                        id: -1,
                        text: this.localizeList.all
                    }
                    res.unshift(idMinusOneItem);
                }

                return res;
            },
            
            setAllCombo(data) {
                this.cashComboSearchValue = "";
                this.comboAllItems = [];
                this.searchComboFunc("", true);

                // Создал объект для выбора "Все", на фронте, т.к. бэк занят
                let chooseAllItems = {
                    hotelName: this.localizeList.all,
                    hotelKey: -1,
                    categoryName: "",
                    categoryKey: "",
                    isHotel: true,
                    isCategory: false,
                    id: -1,
                    text: ""
                };
                this.comboAllItems.push(chooseAllItems);

                data.forEach((x, idx) => {
                        const item = {
                            hotelName: x.Hotel.Name,
                            hotelKey: x.Hotel.Key,
                            categoryName: x.Category.Name,
                            categoryKey: x.Category.Key,
                            isHotel: false,
                            isCategory: false,
                            id: idx,
                            text: ""
                        }

                        this.comboAllItems.push(item);
                });

            },
            keyDown(e) {
                if (e.keyCode === 13) {
                    this.search();
                }
            },
            focusFilter(elem) {
                if (elem === 'cityTo') {
                    this.scrollToFilter()
                }
            },
            scrollToFilter() {
                if (!this.$store.getters['getSearched']) {
                    window.scrollTo({
                        top: this.$refs.quotesFilters.offsetTop,
                        behavior: "smooth"
                    })
                }
            },
            reloadDate() {
                this.date = JSON.parse(methods.getCookieValueByName("quotesDate"))
            },
            showValidation(text) {
                this.validationShow = true;
                this.validationText = text;
            },
            getCountryTo() {
                let apiUrl = this.API_URL + 'QuotedHotels/GetCountry';

                Vue.Api.Get(apiUrl)
                    .then(res => {
                        this.allCountryTo.items = [];
                        let data = res.data;
                        let isCash = false;
                        let allCountryToIds = this.allCountryTo.items.map(x => x.id);
                        let cashTourTo = JSON.parse(methods.getCookieValueByName("quotesTo"));
                        data.filter(x => !allCountryToIds.includes(x.key))
                        .forEach((val) => {
                            this.allCountryTo.items.push({
                                text: val.Country.Name,
                                id: val.Country.Key,
                                isChecked: false
                            });
                            if (
                                cashTourTo && cashTourTo[0] == val.Country.Key
                            ) {
                                isCash = true;
                            }
                        });
                        if (!isCash) {
                            this.searchTour.to = [];
                        } else {
                            const id = cashTourTo[0];
                            if (!id) return;
                            this.getCitiesTo([{ id }])
                                .then((res2) => {
                                    if (!res2) return;
                                    this.searchTour.to = cashTourTo;
                                })
                        }
                    });
            },
            getCitiesToWithCash(e) {
                this.getCitiesTo(e)
                    .then((res) => {
                        if (!window.settings.destCities || !res) return;

                        const citiesKeys = res.data.map(x => x.Key)
                        let settingsDestCities = window.settings.destCities.filter(x => {
                            if (citiesKeys.includes(x)) return x;
                        });
                        if (
                            settingsDestCities?.length &&
                            !(settingsDestCities.length === 1 && settingsDestCities[0] === -1)
                        ) {
                            this.searchTour.to = [ e[0].id, ...settingsDestCities ]
                        }
                    })
            },
            getCitiesTo(country) {
                return new Promise((resolve) => {
                    const api = this.API_URL + 'QuotedHotels/GetCity?countryKey=' + country[0].id;

                    if (api === this.countryOldApi){
                        // const allCitiesTo = [...this.allCitiesTo];
                        // this.allCitiesTo = [];
                        // setTimeout(() => {
                        //     this.allCitiesTo = allCitiesTo;

                        //     resolve();
                        // }, 0);

                        return
                    }
                    this.countryOldApi = api;

                    Vue.Api.Get(api)
                        .then(res => {
                            this.allCitiesTo = [];
                            res.data.forEach(x => {
                                this.allCitiesTo.push({
                                    text: x.City.Name,
                                    id: x.City.Key,
                                    isChecked: false
                                })
                            });
                            resolve(res)
                        })
                });
            },
            getHotelsTo(cities) {
                return new Promise((resolve) => {
                    const api = this.API_URL + 'QuotedHotels/GetHotels?countryKey=' + this.searchTour.to[0] + '&cityKey=' + cities.join("&cityKey=");

                      Vue.Api.Get(api)
                        .then(res => {
                            this.setAllCombo(res.data);
                            resolve(res)
                        }).then(() => {
                            let searchParams = this.$route?.params?.searchParams;
                            if (searchParams && this.getFirstPageLoadFlag) {
                              this.selectedItemsOnReboot = this.comboAllItems.filter(item => 
                                this.hotelsKeys.some(key => key === item.hotelKey)
                              );
                              // this.comboItems.splice()
                              // Поиск при первой загрузке страницы
                              this.search(true)
                            }
                        })
                });
            },
            getQuotaSettings() {
                const api = this.API_URL + 'QuotedHotels/Setting';
                Vue.Api.Get(api)
                    .then(res => {
                        this.$store.commit("quotes/" + mTypesQuotes.M_SET_QUOTA_DESCRIPTION, res.data)
                    })
            },
            search(isCash = false) {
                if (this.searchTour.to.length < 1 && !isCash) {
                    let text = `${this.localizeList.firstSetField} ${this.localizeList.departTo}`;
                    this.showValidation(text);
                    return;
                }
                if (this.searchTour.to.length === 1 && !isCash) {
                    let text = `${this.localizeList.firstSetField} ${this.localizeList.cityUpper}`;
                    this.showValidation(text);
                    return;
                }
                if (!this.hotelsKeys.length && !isCash 
                    || this.hotelsKeys.length && !Object.entries(this.searchTour.combo).length && !isCash) {
                    let text = `${this.localizeList.firstSetField} ${this.localizeList.hotelUpper}`;
                    this.showValidation(text);
                    return
                }
                if (!Object.entries(this.date).length) {
                    let text = `${this.localizeList.firstSetField} ${this.localizeList.whenUpper}`
                    this.showValidation(text);
                    return
                }
                if (!this.date.dates.length) {
                    let text = `${this.localizeList.firstSetField} ${this.localizeList.whenUpper}`
                    this.showValidation(text)
                    return
                }
                if(!this.quotesDaysCount) {
                    let text = `${this.localizeList.firstSetField} ${this.localizeList.periodUpper}`
                    this.showValidation(text)
                    return
                }

                // this.$store.commit("hotels/" + mTypesTour.M_SET_SEARCH_LOADER_STATUS, true)
                // bus.$emit("start-search");
                bus.$emit("page-load", true);

                const cashHotelsKeys = JSON.parse(methods.getCookieValueByName("quotesHotels"));
                let cashPeriod = JSON.parse(methods.getCookieValueByName("quotesPeriod"));
                if (!cashPeriod) cashPeriod = 30;

                let params = {
                  countryTo: this.searchTour.to[0],
                  citiesTo: this.searchTour.to.slice(1),
                  hotels: isCash ? cashHotelsKeys : this.hotelsKeys,
                  dates: this.date.dates[0],
                  period: isCash ? cashPeriod : this.quotesDaysCount,
                }

                this.quotesDaysCountAfterSearch = params.period;

                return new Promise(resolve => {
                    this.$store.dispatch("quotes/A_QUOTES_SEARCH", params)
                        .then(res => {
                            // this.$store.commit("hotels/" + mTypesTour.M_SET_SEARCH_LOADER_STATUS, false)
                            let params = this.$route.fullPath;
                            let newUrl = "/Individuals/Quotes" + res.replace("?", "/");

                            if (params !== newUrl) {
                                let hasParams = this.$route.fullPath.includes("Individuals/Quotes")
                                if (hasParams) {
                                    this.$router.push(newUrl);
                                    this.$nextTick(() => bus.$emit("main-search-status", true))
                                } else {
                                    bus.$emit("change-cash-url-of", newUrl)
                                    this.$nextTick(() => bus.$emit("main-search-status", true))
                                }
                            } else {
                                this.$nextTick(() => bus.$emit("main-search-status", true))
                            }
                            bus.$emit("page-load", false);
                            resolve()
                        })
                    .catch((err) => {
                        this.$store.commit("hotels/" + mTypesTour.M_SET_SEARCH_LOADER_STATUS, false)
                        bus.$emit("page-load", false);
                        console.log(err);
                    });
                })
            },
            handleScroll() {
              const containerElement = this.$refs.quotesFilters;
              if (containerElement) {
                const containerTop = containerElement.getBoundingClientRect().top;
                const currentScrollPosition = window.scrollY || window.pageYOffset;
                const isScrollingDown = currentScrollPosition > this.lastScrollPosition;

                // Добавляем некоторый порог, чтобы определить, когда переключать `fixedDatepicker`
                const thresholdUp = -35;
                const thresholdDown = -100;

                if (isScrollingDown && containerTop <= thresholdDown) {
                  this.fixedDatepicker = true;
                } else if (!isScrollingDown && containerTop > thresholdUp) {
                  this.fixedDatepicker = false;
                }

                this.lastScrollPosition = currentScrollPosition;
              }
            },
        },
        watch: {
            activeDates: {
                deep: true,
                handler(val, oldVal) {
                    if (JSON.stringify(val) === JSON.stringify(oldVal)) {
                        return
                    }
                    const minDate = new Date().getTime();
                    this.activeDates = val.filter(x => {
                        const date = x.split(".").reverse();
                        return new Date(...date).getTime() > minDate
                    });
                }
            },
            'searchTour.to'(val, oldVal) {
                let isRepeat = methods.checkEquality(val, oldVal);
                document.cookie = `quotesTo=${JSON.stringify(val)}; path=/`;
                if (
                    !isRepeat && (val.length > 1)
                ) {
                    this.comboAllItems = [];
                    this.comboItems = [];
                    this.searchTour.combo = {};
                    const cities = val.slice(1)
                    this.getHotelsTo(cities).then(() => {
                      const cashDate = JSON.parse(methods.getCookieValueByName("quotesDate"));
                      if (cashDate) {
                        this.date = cashDate;
                      }
                    })
                    this.$store.commit("quotes/" + mTypesQuotes.M_SET_SEARCH_RESULT, [])
                    this.$store.commit("quotes/" + mTypesQuotes.M_SET_SHOW_QUOTES, false)
                }
            },
            hotelsKeys(val) {
                let quotesHotels = JSON.stringify(val);
                document.cookie = `quotesHotels=${quotesHotels}; path=/`;
            },
            'date.dates'(val, oldVal) {
                let isRepeat = methods.checkEquality(val, oldVal);
                if (!isRepeat && !this.getFirstPageLoadFlag) {
                  this.$store.commit("quotes/" + mTypesQuotes.M_SET_SEARCH_RESULT, [])
                  this.$store.commit("quotes/" + mTypesQuotes.M_SET_SHOW_QUOTES, false)
                }
            },
            quotesDaysCount(val, oldVal) {
                let isRepeat = methods.checkEquality(val, oldVal);
                if (!isRepeat) {
                  let quotesPeriod = JSON.stringify(val);
                  document.cookie = `quotesPeriod=${quotesPeriod}; path=/`;
              }
            }
        }
    }
</script>
<style scoped>
    .search-bar {
        padding: 10px 60px;
        background-color: var(--white-color);
        display: grid;
        grid-template-columns: 1fr 2fr 0.5fr auto auto;
        grid-gap: 4px;
    }

    .search-bar .days-count .days-count-label {
        height: 35px;
    }

    .search-bar .days-count .days-count-label {
        display: flex;
        gap: 4px;
        height: 35px;
        align-items: center;
    }

    .search-bar .search-bar-item .days-count-input {
        text-align: center;
        max-width: 50px;
        padding: 8px;
        border: none;
        outline: none;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
    }

    .search-bar .search-bar-item .days-count-label span {
        font-weight: bold;
    }

    .setting-items {
      display: flex;
      column-gap: 20px;
      align-items: center;
      padding: 10px 60px;
      background-color:  var(--white-color);
    }

    .setting-items .setting-item {
      display: flex;
      align-items: center;
      column-gap: 5px;
      color: black !important;
    }

    .setting-items .setting-item :first-child {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--lighten-3-color);
      border-radius: 3px;
      padding: 5px;
      min-width: 30px;
      height: 30px;
    }

    .setting-items .setting-item .seats {
      background-color: var(--green-4-color);
    }

    .setting-items .setting-item .request-seats {
      background-color: var(--yellow-color);
    }

    .setting-items .setting-item .no-seats {
      background-color: var(--red-color);
    }

    .setting-items .setting-item .few-seats {
      background-color: #319AE6;
    }
</style>
